import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import "../../platform_spaces/space/SpaceStyle.css";

export function ProductBundleHubPage(props: { row: MembershipProduct }): JSX.Element {
  const names = props.row.bundledProductDisplayNames ?? [];
  return (
    <div className="space-section-placeholder space-bundle-hub">
      <p className="space-bundle-hub__title">套餐已开通，包含以下产品权益：</p>
      {names.length > 0 ? (
        <ul className="space-bundle-hub__list">
          {names.map((name: string) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      ) : (
        <p className="space-bundle-hub__empty">请从左侧导航进入各产品使用。</p>
      )}
    </div>
  );
}
